import { FormlyFieldConfig } from "@ngx-formly/core";
import { RichiestaDehorStep } from "./steps/richiesta-dehor.step";
import { OccupazioneDehorStep } from "./steps/occupazione-dehor.step";
import { AllegatiDehorStep } from "./steps/allegati-dehor";
import { GiuridicaStep } from "app/forms/shared/giuridica.step";
import { IntestatarioStep } from "app/forms/shared/intestatario.step";
import { PrivacyDelegaStep } from "app/forms/shared/privacy-delega.step";
import { UbicazioneStep } from "../shared/ubicazione.step";
import { IntestatarioTipo } from "app/forms/shared/intestatario.tipo";


export const Dehor : FormlyFieldConfig[] = [
        {
            props: {
                slabel: "PRIVACY",
                label: "INFORMATIVA SULLA PRIVACY"
            },
            wrappers: ['panel-step'],
            fieldGroup: PrivacyDelegaStep
        },
        {
            props: {
                slabel: "INTESTATARIO",
                label: "DATI ANAGRAFICI INTESTATARIO"
            },
            wrappers: ['panel-step'],
            fieldGroup: [...IntestatarioTipo, ...IntestatarioStep, ...GiuridicaStep]
        },
      {
        props: {
          slabel: "UBICAZIONE",
          label: "UBICAZIONE DEL DEHOR IN MAPPA",
        },
        wrappers: ['panel-step'],
        fieldGroup: UbicazioneStep
      },
      {
        props: {
          slabel: 'RICHIESTA',
          label: 'DATI DELLA RICHIESTA'
        },
        wrappers: ['panel-step'],
        fieldGroup: RichiestaDehorStep
      },
      {
        props: {
          slabel: 'OCCUPAZIONE',
          label: 'ELEMENTI DI OCCUPAZIONE SUOLO PER DEHOR'
        },
        wrappers: ['panel-step'],
        fieldGroup: OccupazioneDehorStep
      },
      {
        props: {
          slabel: 'ALLEGATI',
          label: 'DOCUMENTAZIONE ALLEGATA'
        },
        wrappers: ['panel-step'],
        fieldGroup: AllegatiDehorStep
      },
    ]
